import * as types from "../../actions/actionTypes";

const initialState = {
  data: {},
  loading: true,
  error: ""
};

const PettyCashierCurrentPettyCashBudgetComparativeReport = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case types.PETTY_CASHIER_GET_CURRENT_PETTY_CASH_BUDGET_COMPARISON_INFO_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.PETTY_CASHIER_GET_CURRENT_PETTY_CASH_BUDGET_COMPARISON_INFO_SUCCESS:
      return { ...state, data: { data: action.payLoad }, loading: false };
    case types.PETTY_CASHIER_GET_CURRENT_PETTY_CASH_BUDGET_COMPARISON_INFO_FAILURE:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default PettyCashierCurrentPettyCashBudgetComparativeReport;
